<template>
  <div class="about">
    <div class="top">
      <div class="top_title">保理法律法规</div>
      <div>
        <current-path>
          <template slot="fatherPath">
            首页
          </template>
          <template slot="sonPath">
            保理法律法规
          </template>
        </current-path>
      </div>
    </div>
    <div class="contentList">
      <news-list-item :data='list4'></news-list-item>
      <news-list-item :data='list5'></news-list-item>
    </div>
  </div>
</template>
<script>
import CurrentPath from '../../components/CurrentPath.vue'
import NewsListItem from '@/components/newsComponentsItem/NewsListItem'
export default {
  components: { CurrentPath, NewsListItem },
  data () {
    return {
      currentTab: 1,
      isShowDetail: 0,
      isShowDetail_lay: 0,
      list4: {
        id: 222,
        imgSrc: require ('@/assets/home/u176.png'),
        date: '2018-08-11 12:32:56',
        seer: '16',
        title: '商业保理企业管理办法',
        content: '第一章 总则第一条 立法依据为规范商业保理企业经营行为，防范行业风险，促进商 业保理行业健康发展，根据《合同法》、《公司法》、《物权法》 和有关外商投资的法律、行政法规，特制定本办法……'
      },
      list5: {
        id: 223,
        imgSrc: require ('@/assets/home/u178.png'),
        date: '2018-08-05 18:40:23',
        seer: '19',
        title: '应收账款质押登记办法',
        content: '第一章 总 则第一条 为规范应收账款质押登记，保护质押当事人和利害关系人的合法权 益，根据《中华人民共和国物权法》，制定本办法。第二条 中国人民银行征信中心(以下简称征信中心)是应收账款质押的登 记机构。'
      },
    }
  },
  methods: {
    changeTab (index) {
      this.currentTab = index
    },
    changeShow (index) {
      if (this.isShowDetail === index) {
        this.isShowDetail = 0
      } else {
        this.isShowDetail = index
      }
    },
    changeShow_lay (index) {
      if (this.isShowDetail_lay === index) {
        this.isShowDetail_lay = 0
      } else {
        this.isShowDetail_lay = index
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.about
  width 1200px
  margin 0 auto
  transform translateY(-40px)
.top
  width 900px
  padding 10px 20px
  background-color #ffffff
  margin 0 auto
  overflow hidden
  display flex
  justify-content space-between
  .top_title
    font-size 18px
    width 100px
    padding-bottom 10px
    border-bottom 1px solid #008000
.about_tab
  display flex
  justify-content flex-start
  margin-top 10px
  border-bottom 1px solid #CCCCCC
  padding-bottom: 20px;
  div
    padding 10px 20px
    font-size 18px
.activeTab
  background-color #E6AC00
  color #ffffff
  position relative
  &::after
    content ''
    display block
    position absolute
    width:0;
    height:0;
    border-width:7px 7px 0;
    border-style:solid;
    border-color:#E6AC00 transparent transparent;/* */
    left 48px
    bottom -7px
.about_content
  margin-top 20px
  font-size 16px
  line-height 32px
  min-height 200px
  .idtent
    text-indent 32px

.list
  width 100%
  margin-top 10px
  .list_title
    position relative
    border 1px solid #CCCCCC
    font-size 18px
    height 50px
    text-indent 3*@font-size
    line-height @height
  .child_detail
    width @width
    background #FBFBFB
    padding 20px 10px
    border 1px solid #CCCCCC
    border-top none
    overflow hidden
    // transition:height 2s;
    // -moz-transition:height 2s; /* Firefox 4 */
    // -webkit-transition:height 2s; /* Safari and Chrome */
    // -o-transition:height 2s; /* Opera */
    p
      font-size 15px
.list_add
.list_less
  position absolute
  width 20px
  height @width
  top 16px
  left 20px
.list_add
  background url(../../assets/baike/u106.png) no-repeat center center
  background-size 110% 110%;
.list_less
  background url(../../assets/baike/u107.png) no-repeat center center
  background-size 110% 110%;

.fade-enter-active
.fade-leave-active {
  transition: all .2s
}
.fade-enter
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.contentList
  margin-top 20px
</style>
